import styled from 'styled-components'

export const Card = styled.div`
  border-radius: 4px;
  padding: 8px 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;

export const OrderNumber = styled.div`
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 4px;
`;

export const OrderDetails = styled.div`
  font-size: 0.8rem;
  color: #666;
  display: flex;
  justify-content: space-between;
`;
